// Module
var code = "<oc-form name=\"vm.form\"> <amt-content> <oc-comment max-length=\"500\" rows=\"8\" ng-required=\"true\" ng-model=\"vm.stocktakeComment.comment\"> </oc-comment> </amt-content> </oc-form>";
// Exports
module.exports = code;